export default "__VITE_ASSET__1d7da10c__"